import React from 'react'

/**
 * Catches render errors and failed lazy chunks (React.lazy rejects leave Suspense without a fallback).
 */
export class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { err: null }
  }

  static getDerivedStateFromError(err) {
    return { err }
  }

  componentDidCatch(err, info) {
    console.error('[RouteErrorBoundary]', err, info?.componentStack)
  }

  render() {
    if (this.state.err) {
      const msg = String(this.state.err?.message || this.state.err)
      return (
        <div className="rounded-lg border border-rose-500/30 bg-rose-500/[0.08] p-4 text-sm text-rose-900 dark:text-rose-100/90">
          <p className="font-medium">This page failed to load.</p>
          <p className="mt-2 break-words font-mono text-xs opacity-90">{msg}</p>
          <button
            type="button"
            className="mt-4 rounded-lg border border-rose-500/40 bg-white/80 px-3 py-1.5 text-xs font-medium text-rose-900 hover:bg-white dark:bg-slate-900/80 dark:text-rose-100 dark:hover:bg-slate-800"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
